"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var react_socks_1 = __importDefault(require("react-socks"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Label_1 = __importDefault(require("./styledComponents/Label"));

var ContextMenuItemIcon_1 = __importDefault(require("./styledComponents/ContextMenuItemIcon"));

var DocumentLabel_1 = __importDefault(require("./styledComponents/DocumentLabel"));

var DocumentItemWrapper_1 = __importDefault(require("./styledComponents/DocumentItemWrapper"));

var DocumentDownload_meta_1 = require("./DocumentDownload.meta");

var mobx_1 = require("mobx");

var Translate_1 = __importDefault(require("../../base/Translate"));

var Icon_1 = __importDefault(require("../../base/Icon"));

var ContextMenu_1 = __importDefault(require("../../base/ContextMenu"));

var Checkbox_1 = __importDefault(require("../../base/Checkbox"));

var Translate_2 = require("../../base/Translate/Translate");

var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];

var DocumentDownload = function (_super) {
  __extends(DocumentDownload, _super);

  function DocumentDownload(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = DocumentDownload_meta_1.DOCUMENT_DOWNLOAD_CATEGORY_KEY;
    _this.componentKey = DocumentDownload_meta_1.DOCUMENT_DOWNLOAD_COMPONENT_KEY;
    _this.documentDownloadIconKey = 'base.documentDownload.icon';
    _this.documentDownloadSpinnerKey = 'base.documentDownload.spinner';
    _this.documentLabelIconKey = 'base.documentDownload.documentLabelIcon';
    _this.documentDownloadState = {};

    _this.handleItemToggle = function (id, selected) {
      var onItemToggle = _this.props.onItemToggle;

      if (onItemToggle) {
        onItemToggle(id, selected);
      }
    };

    _this.handleDownloadClick = function (docId, payload) {
      return __awaiter(_this, void 0, void 0, function () {
        var onDownloadClick, canDownload, result;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              onDownloadClick = this.props.onDownloadClick;
              canDownload = !this.isDownloading(docId);
              if (!(onDownloadClick && canDownload)) return [3
              /*break*/
              , 2];
              this.setItemDownloading(docId);
              return [4
              /*yield*/
              , onDownloadClick(payload)];

            case 1:
              result = _a.sent();

              if (result) {
                this.completeItemDownloading(docId);
              }

              _a.label = 2;

            case 2:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.handleKeyDown = function (event, docId, payload) {
      var key = event.key;

      if (ACCEPT_KEYS.indexOf(key) !== -1) {
        _this.handleDownloadClick(docId, payload);
      }
    };

    return _this;
  }

  Object.defineProperty(DocumentDownload.prototype, "hasMultipleDocuments", {
    get: function get() {
      var documents = this.props.documents;
      return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(documents) && documents.length > 1;
    },
    enumerable: true,
    configurable: true
  });

  DocumentDownload.prototype.setItemDownloading = function (id) {
    this.toggleItemDownloading(id, true);
  };

  DocumentDownload.prototype.completeItemDownloading = function (id) {
    this.toggleItemDownloading(id, false);
  };

  DocumentDownload.prototype.toggleItemDownloading = function (id, isDownloading) {
    this.documentDownloadState[id] = isDownloading;
    this.documentDownloadState = Object.assign({}, this.documentDownloadState);
  };

  DocumentDownload.prototype.isDownloading = function (id) {
    return this.documentDownloadState && this.documentDownloadState[id];
  };

  DocumentDownload.prototype.singleDocument = function (props) {
    var _this = this;

    var documents = props.documents,
        hideLabel = props.hideLabel,
        _a = props.useSpinner,
        useSpinner = _a === void 0 ? true : _a,
        _b = props.iconPosition,
        iconPosition = _b === void 0 ? 'after' : _b,
        describedById = props.describedById;

    if (documents && documents.length === 1) {
      var docId_1 = documents[0].id;
      var iconAsset = this.isDownloading(docId_1) && useSpinner ? this.documentDownloadSpinnerKey : this.documentDownloadIconKey;
      var label = react_1.default.createElement(Label_1.default, null, react_1.default.createElement(Translate_1.default, null, documents[0].label));
      var ariaLabelText = documents[0].label + " download";

      if (this.translationContext) {
        var translateFn = this.translationContext.translate;
        ariaLabelText = translateFn(ariaLabelText);
      }

      var icon = react_1.default.createElement(Icon_1.default, {
        asset: iconAsset
      });
      return react_1.default.createElement(DocumentLabel_1.default, {
        onClick: function onClick() {
          return _this.handleDownloadClick(docId_1, documents[0].payload);
        },
        onKeyDown: function onKeyDown(e) {
          return _this.handleKeyDown(e, docId_1, documents[0].payload);
        },
        tabIndex: 0,
        "aria-describedby": describedById,
        "aria-label": ariaLabelText,
        role: "button"
      }, iconPosition === 'before' && icon, !hideLabel && label, iconPosition === 'after' && icon);
    }
  };

  DocumentDownload.prototype.multipleDocuments = function (props) {
    var _this = this;

    var documents = props.documents,
        availableLabel = props.availableLabel,
        selectionLabel = props.selectionLabel,
        allowSelection = props.allowSelection,
        showPill = props.showPill,
        hideLabel = props.hideLabel,
        _a = props.dropdownLabelType,
        dropdownLabelType = _a === void 0 ? 'text' : _a,
        pillProps = props.pillProps,
        _b = props.useSpinner,
        useSpinner = _b === void 0 ? true : _b,
        _c = props.iconPosition,
        iconPosition = _c === void 0 ? 'after' : _c,
        describedById = props.describedById;

    if (documents && this.hasMultipleDocuments) {
      var selectedDocuments = documents.filter(function (document) {
        return document.selected;
      });
      var label = availableLabel || '';

      if (allowSelection && selectionLabel && selectedDocuments && selectedDocuments.length > 0) {
        label = selectionLabel;
      }

      var values = {
        selected: selectedDocuments.length,
        available: documents.length
      };

      if (this.translationContext) {
        label = this.translationContext.translate(label, values);
      }

      label = ksys_app_template_1.utils.replacePlaceholders(values, label);

      if (showPill) {
        if (allowSelection) {
          label = values.selected.toString();
        } else {
          label = values.available.toString();
        }
      } else if (hideLabel) {
        label = '';
      }

      var labelIcon = void 0;

      if (dropdownLabelType === 'icon') {
        labelIcon = {
          asset: this.documentLabelIconKey
        };
      }

      var contextMenuComponent = react_1.default.createElement(ContextMenu_1.default, {
        label: label,
        labelIcon: labelIcon,
        showPill: showPill,
        pillProps: pillProps,
        isMultiSelect: true,
        onChildSelection: function onChildSelection(e, index) {
          var document = documents[index];

          if (allowSelection) {
            _this.handleItemToggle(document.id, !document.selected);
          } else {
            _this.handleDownloadClick(document.id, document.payload);
          }
        },
        describedById: describedById
      }, documents.map(function (document) {
        var iconAsset = _this.isDownloading(document.id) && useSpinner ? _this.documentDownloadSpinnerKey : _this.documentDownloadIconKey;
        var documentLabel;

        if (allowSelection) {
          documentLabel = react_1.default.createElement(Checkbox_1.default, {
            key: document.id,
            label: document.label,
            value: document.selected
          });
        } else {
          documentLabel = react_1.default.createElement(Label_1.default, null, react_1.default.createElement(Translate_1.default, null, document.label));
        }

        var icon = react_1.default.createElement(ContextMenuItemIcon_1.default, {
          onClick: function onClick(e) {
            if (allowSelection) {
              e.preventDefault();
              e.stopPropagation();

              _this.handleDownloadClick(document.id, document.payload);
            }
          }
        }, react_1.default.createElement(Icon_1.default, {
          asset: iconAsset
        }));
        return react_1.default.createElement(DocumentItemWrapper_1.default, {
          key: document.id,
          onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();

            if (!allowSelection) {
              _this.handleDownloadClick(document.id, document.payload);
            } else {
              _this.handleItemToggle(document.id, !document.selected);
            }
          }
        }, iconPosition === 'before' && icon, react_1.default.createElement(DocumentLabel_1.default, null, documentLabel), iconPosition === 'after' && icon);
      }));
      return contextMenuComponent;
    }
  };

  DocumentDownload.prototype.render = function () {
    var _this = this;

    var breakpoints = this.breakpoints; // Add observable to render in order for state changes to force renders

    this.documentDownloadState;
    return react_1.default.createElement(react_1.Fragment, null, breakpoints.map(function (breakpoint, breakpointIndex) {
      var props = breakpoint.props;

      if (props) {
        var breakpointProps_1 = _this.getBreakpointComponentProps(breakpoint, breakpointIndex);

        var className_1 = props.className;
        return react_1.default.createElement(Translate_2.TranslationContext.Consumer, null, function (translationContext) {
          _this.translationContext = translationContext;
          return react_1.default.createElement(react_socks_1.default, __assign({}, breakpointProps_1), react_1.default.createElement(Wrapper_1.default, {
            className: className_1
          }, _this.hasMultipleDocuments ? _this.multipleDocuments(props) : _this.singleDocument(props)));
        });
      }
    }));
  };

  __decorate([mobx_1.observable], DocumentDownload.prototype, "documentDownloadState", void 0);

  __decorate([mobx_1.computed], DocumentDownload.prototype, "hasMultipleDocuments", null);

  DocumentDownload = __decorate([mobx_react_1.observer], DocumentDownload);
  return DocumentDownload;
}(shared_1.ResponsiveComponentBase);

exports.DocumentDownload = DocumentDownload;
exports.default = shared_1.InjectedStyledComponent(DocumentDownload, DocumentDownload_meta_1.DOCUMENT_DOWNLOAD_CATEGORY_KEY, DocumentDownload_meta_1.DOCUMENT_DOWNLOAD_COMPONENT_KEY);